module.exports = __webpack_public_path__ + "assets/img/glace_fruit_active.5c079e55.png";